(() => {
  'use strict';

  const MENU_SELECTOR = '[data-faj-footer-menu]';
  const DESKTOP_QUERY = '(min-width: 750px)';
  const mediaQuery = window.matchMedia(DESKTOP_QUERY);

  function initializeMenu(menu) {
    if (menu.dataset.fajMenuReady === 'true') return;

    menu.dataset.fajMenuReady = 'true';
    menu.dataset.mobileState = menu.dataset.mobileOpen === 'true' ? 'true' : 'false';

    menu.addEventListener('toggle', () => {
      if (!mediaQuery.matches && menu.dataset.fajRestoring !== 'true') {
        menu.dataset.mobileState = menu.open ? 'true' : 'false';
      }
    });
  }

  function syncMenu(menu) {
    initializeMenu(menu);

    if (mediaQuery.matches) {
      menu.dataset.fajRestoring = 'true';
      menu.open = true;
      menu.dataset.fajRestoring = 'false';
      return;
    }

    menu.dataset.fajRestoring = 'true';
    menu.open = menu.dataset.mobileState === 'true';
    menu.dataset.fajRestoring = 'false';
  }

  function syncAll(scope = document) {
    if (scope.matches?.(MENU_SELECTOR)) {
      syncMenu(scope);
    }

    scope.querySelectorAll?.(MENU_SELECTOR).forEach(syncMenu);
  }

  function handleBreakpointChange() {
    document.querySelectorAll(MENU_SELECTOR).forEach(syncMenu);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => syncAll(), { once: true });
  } else {
    syncAll();
  }

  if (typeof mediaQuery.addEventListener === 'function') {
    mediaQuery.addEventListener('change', handleBreakpointChange);
  } else {
    mediaQuery.addListener(handleBreakpointChange);
  }

  document.addEventListener('shopify:section:load', (event) => {
    syncAll(event.target);
  });

  document.addEventListener('shopify:block:select', (event) => {
    const menu = event.target.closest?.(MENU_SELECTOR);
    if (!menu) return;

    initializeMenu(menu);

    if (!mediaQuery.matches) {
      menu.open = true;
      menu.dataset.mobileState = 'true';
    }
  });
})();
